




















import { Vue, Component, Prop } from 'vue-property-decorator'
import 'semantic-ui-css/components/progress.min.css'

@Component
export default class SigmaLeaderboardItem extends Vue {
  @Prop(Number) readonly index!: number
  @Prop(String) readonly icon!: string
  @Prop(String) readonly name!: string
  @Prop(String) readonly avatar!: string
  @Prop(Number) readonly value!: number
  @Prop(Number) readonly level!: number
  @Prop(Number) readonly nextRequired!: number
  @Prop(Number) readonly nextPercentage!: number
  @Prop(Number) readonly tier!: number
  @Prop(String) readonly title!: string

  prestige () {
    return Math.floor(this.level / 100)
  }

  numberWithCommas (x: number) {
    let y = x.toString()
    var pattern = /(-?\d+)(\d{3})/
    while (pattern.test(y)) {
      y = y.replace(pattern, '$1,$2')
    }
    return y
  }
}
